(function(root, document, $) {
	'use strict';
	var app = {
		init : function() {
			this.win = $(window);
			this.doc = $(document);
			this.body = $('body');

			for (var name in this) {
				if (typeof(this[name].init) === 'function') {
					this[name].init();
				}
			}
		},

		mainFunctions : {
			init : function() {
				var scope = this;

				scope.scrollToTop();
				scope.tableContainer();
			},

			scrollToTop : function() {
				var $trigger = $('.back-to-top');

				$trigger.click(function(e) {
					e.preventDefault();

					$('html, body').animate({
						scrollTop: 0
					}, 800);
				});
			},

			tableContainer : function() {
				var $tables = $('.editor_content table');

				$tables.each(function() {
					$(this).wrap('<div class="table-container">');
				})
			}
		},

		menuFunctions : {
			init : function() {
				var scope = this;
				var tabletWidth = 1440;

				scope.dropdownSub();
				scope.showSearch();
				scope.mobileMenu(tabletWidth);
				scope.subMenu();
			},

			dropdownSub : function() {
				var trigger = '.primary-navigation>ul ul .show-sub';

				$(document).on('click', trigger, function() {
					var $this = $(this);
					$this.toggleClass('active');
					var $subMenu = $this.next('ul');
					$subMenu.slideToggle();
				});
			},

			showSearch : function() {
				var $trigger = $('.toggle-search');
				var $searchBox = $('.search-box');

				$trigger.click(function() {
					$searchBox.slideToggle();
					$(this).toggleClass('active');
				})
			},

			mobileMenu : function(tabletWidth) {
				var $trigger = $('.toggle-navigation');
				var $menu = $('.primary-navigation');
				var $showSub = $('.primary-navigation > ul > li > .show-sub');

				$trigger.click(function(e) {
					if($menu.hasClass('visible')) {
						$('.page-overlay').remove();
					}else{
						app.body.append('<div class="page-overlay side-menu-overlay"></div>')
					}
					$(this).toggleClass('active');
					$menu.toggleClass('visible');
				});
				app.body.on('click', '.side-menu-overlay, .close-side-menu', function (){
					$menu.removeClass('visible');
					$('.page-overlay').remove();
				});
				$showSub.click(function() {
					var windowWidth = app.win.width();

					if(windowWidth < tabletWidth ) {
						$(this).next('ul').slideToggle();
						$(this).toggleClass('active');
					}
				});
			},

			subMenu : function() {
				var $trigger = $('.content-submenu-component .show-sub');

				$trigger.click(function() {
					var $this = $(this);
					var $subMenu = $this.next('ul');

					$this.toggleClass('active');
					$subMenu.slideToggle();
				});
			}
		},

		formFunctions : {
			init : function() {
				var scope = this;

				scope.placeholderLabel();
				scope.fileUpload();
				scope.contactBlockDesc();
				scope.select2();

				app.doc.bind('gform_post_render', function(){
					scope.placeholderLabel();
					scope.fileUpload();
					scope.contactBlockDesc();
					scope.select2();
				});

			},

			placeholderLabel : function() {
				var trigger = '.gform_wrapper:not(.no_label_input_wrapper) input, .gform_wrapper textarea, .search-form input, p.login-username input, p.login-password input';
				var $labels = $('.gform_wrapper:not(.no_label_input_wrapper) .gform_text .gfield_label, .gform_wrapper:not(.no_label_input_wrapper) .gform_email .gfield_label, .gform_wrapper:not(.no_label_input_wrapper) .gform_textarea .gfield_label, .gform_wrapper:not(.no_label_input_wrapper) .gform_phone .gfield_label, .gform_wrapper:not(.no_label_input_wrapper) .gform_website .gfield_label, .gform_wrapper:not(.no_label_input_wrapper) .gform_number .gfield_label');
				var $fileuploadLabels = $('.gform_wrapper:not(.no_label_input_wrapper) .gform_fileupload .gfield_label');

				$labels.each(function() {
					var $target = $(this).siblings('.ginput_container');
					$target.append($(this));
				});

				$fileuploadLabels.each(function() {
					var $input = $(this).siblings('.ginput_container').find('input[type="file"]');
					$(this).insertAfter($input);
				});

				app.body.on('focus', trigger, function(e) {
					var label = $(this).siblings('label');
					label.addClass('input_focus');
				});
				app.body.on('blur', trigger, function(e) {
					if($(this).val() == '') {
						var label = $(this).siblings('label');
						label.removeClass('input_focus');
					}
				});
				app.doc.ready( function() {
					$(trigger).each(function(e) {
						if($(this).val() != '') {
							var label = $(this).siblings('label');
							label.addClass('input_focus');
						}
					});
				});
			},

			fileUpload : function() {
				var $fileUpload = $('.gform_wrapper:not(.no_label_input_wrapper) .gform_fileupload input[type="file"]');

				$fileUpload.each( function() {
					var $input	 = $( this ),
						$label	 = $input.next( 'label' ),
						labelVal = $label.html();

					$input.on( 'change', function(e) {
						var fileName = '';

						if( this.files && this.files.length > 1 ) {
							//Multiple files, needs to find solution
						}else if(e.target.value) {
							fileName = e.target.value.split( '\\' ).pop();
						}

						$label.next( '.files' ).remove();

						if( fileName ) {
							$('<p class="files">' + fileName + '</p>').insertAfter($label);
							//$label.find( 'span' ).html( fileName );
						}else{
							
						}
					});
				});
			},

			contactBlockDesc : function() {
				var $formDesc = $('.contact-block-component .gform_description');
				var $formDescTarget = $formDesc.closest('.gform_wrapper').find('.gform_footer');

				$formDesc.appendTo($formDescTarget);
			},

			select2 : function() {
				var $selects = $('select');

				$selects.each(function() {
					var $this = $(this);
					var placeholder = $this.data('placeholder');
					var className = $this.attr("class");
					if(!placeholder) {
						var $placeholderElement = $this.parent().siblings('.gfield_label');
						var placeholder = $placeholderElement.text();
						$placeholderElement.hide();
					}

					var select2Args = {
						width:"style", 
						minimumResultsForSearch:-1
					}; 

					if(placeholder) {
						select2Args['placeholder'] = placeholder;
					}

					if(className) {
						select2Args['containerCssClass'] = className;
						select2Args['dropdownCssClass'] = className;
					}

					$this.select2(select2Args);
				});

			},

			//If no URL is supplied, it is pulled automatically
			//If no value is supplied, the key is removed from the URL
			UpdateQueryString : function(key, value, url) {
				if (!url) url = window.location.href;
				var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
					hash;

				if (re.test(url)) {
					if (typeof value !== 'undefined' && value !== null)
						return url.replace(re, '$1' + key + "=" + value + '$2$3');
					else {
						hash = url.split('#');
						url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
						if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
							url += '#' + hash[1];
						return url;
					}
				}
				else {
					if (typeof value !== 'undefined' && value !== null) {
						var separator = url.indexOf('?') !== -1 ? '&' : '?';
						hash = url.split('#');
						url = hash[0] + separator + key + '=' + value;
						if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
							url += '#' + hash[1];
						return url;
					}
					else
						return url;
				}
			}

		},

		cisionFunctions : {
			init : function() {
				var scope = this;

				scope.sharePriceWidget();
				scope.filterFinancialReports();
			},

			sharePriceWidget : function() {
				var $primaryNavigation = $('.primary-navigation');
				var $heroShare = $('.hero-component footer .container-fluid');
				var $bannersShare = $('.banners-component .share-info');

				$.ajax({
					method: 'GET',
					url: 'https://publish.ne.cision.com/papi/Ticker/EC62BF230D08493AA7B00E6908F69CB1/Performance',
					success: function(response) {

						if (!response.Instruments || !response.Instruments.length) {
							return;
						}

						var data = response.Instruments[0];

						//console.log(data);

						var diffValue = Math.round(data.Diff1D * 100) / 100,
							diffPercent = Math.round(data.Diff1DPrc * 100) / 100,
							date = new Date(data.LastUpdate),
							lastUpdated = '',
							price = data.LastPrice + ' ' + data.TradeCurrency,
							shareContent = '';

						if (diffValue >= 0) {
							diffValue = '+' + diffValue;
						}

						if (diffPercent >= 0) {
							diffPercent = '+' + diffPercent;
						}

						shareContent = '<span class="price">' + price + '</span>';


						if(!isNaN(diffValue)){
							var change = diffValue + ' (' + diffPercent + '%)';
							shareContent += '<span class="change">' + change + '</span>';
						}

						// $primaryNavigation.children('ul').append('<li class="share-price-container"><span class="share-price">' + shareContent + '</span></li>');

						if($heroShare.length) {
							var heroShareContent = '';

							var localTimeString = date.toLocaleTimeString(undefined, {
								hour: '2-digit',
								minute: '2-digit',
							});

							heroShareContent += '<div class="left">';
							heroShareContent += '<span>' + data.Symbol + '/' + data.MarketPlace + '</span>';
							heroShareContent += '<span>' + localTimeString + '</span>';
							heroShareContent += '<span class="price">' + price + '</span>';
							heroShareContent += '<span>' + diffPercent + '%</span>';
							heroShareContent += '</div>';

							heroShareContent += '<div class="right">';
							heroShareContent += '<span>ASK: ' + data.AskPrice + '</span>';
							heroShareContent += '<span>BID: ' + data.BidPrice + '</span>';
							heroShareContent += '<span>HIGH: ' + data.DayHighPrice + '</span>';
							heroShareContent += '<span>LOW: ' + data.DayLowPrice + '</span>';
							heroShareContent += '<span>VOLUME: ' + data.NumTrades + '</span>';
							heroShareContent += '</div>';

							$heroShare.append(heroShareContent);
						}

						if($bannersShare.length) {

							var localTimeString = date.toLocaleTimeString(undefined, {
								hour: '2-digit',
								minute: '2-digit',
							});

							var bannerShareDate = date.getDate() + ' ' + handicare.monthNames[date.getMonth()] + ' ' + date.getFullYear() + ' ' + localTimeString;

							$bannersShare.find('.updated-date').append(bannerShareDate);
							$bannersShare.find('.share-price').append(shareContent);
						}

					}
				});
			},

			filterFinancialReports : function() {
				var $financialFilter = $('.component-sub-financial-reports .dropdowns select, .component-sub-press-releases .dropdowns select');
				$financialFilter.on('change', function() {
					var value = this.value;
					if(value == 'all')
						value = null;
					
					var selectClasses = $(this).attr('class');
					var firstClass = selectClasses.split(" ")[0]; 
					
					var url = app.formFunctions.UpdateQueryString(firstClass, value);
					window.location.href = url;
				});
			}
		},

		certificate : {
			init : function() {
				var $trigger = $('.certificate p.readmore a');

				$trigger.click(function(e) {
					e.preventDefault();

					var $this = $(this);
					$this.toggleClass('active');
					var $content = $this.parent().next('.content');

					$content.slideToggle();
				});
			}
		},

		gridder : {
			init : function() {
				$('.gridder').gridderExpander({
					scroll: false,
					scrollOffset: 30,
					scrollTo: "panel",                  // panel or listitem
					animationSpeed: 400,
					animationEasing: "easeInOutExpo",
					showNav: false,                      // Show Navigation
					nextText: "Next",                   // Next button text
					prevText: "Previous",               // Previous button text
					closeText: "Close",                 // Close button text
					onStart: function(){
						//Gridder Inititialized
					},
					onContent: function(t){
						t.siblings('.arrow').removeClass('arrow fadeOutArrow');
						t.prev().removeClass('fadeOutArrow').addClass('arrow');
					},
					onClosed: function(t){
						t.find('.arrow').addClass('fadeOutArrow');
						 setTimeout(function(){ 
						 	t.find('.arrow').removeClass('fadeOutArrow arrow');
						 }, 200);
					}
				});
			}
		},

		fancybox : {
			init : function() {
				$.fancybox.defaults.buttons = [ "download", "close" ]; 

				var closeButton = '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">';
				closeButton += '<i class="fas fa-times"></i>';
				closeButton += '</button>';

				var downloadButton = '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;">';
				downloadButton += '<i class="fas fa-download"></i>';
				downloadButton += '</a>';

				$.fancybox.defaults.btnTpl.download = downloadButton; 
				$.fancybox.defaults.btnTpl.close = closeButton; 

				$(document).on('afterShow.fb', function( e, instance, slide ) {
					var $slide = slide.$slide;
					var $toolbar = $slide.parent().siblings('.fancybox-toolbar');
					var $target = $slide.find('img');
					$toolbar.insertAfter($target);
				});
			}
		},

		geolocationBanner : {
			init : function() {
				$.ajax({
					url: handicare.ajax_url,
					method: 'POST',
					data: { action: 'theme_location_banner' },
					success: function (response) {
						if (response.success && response.data.banner) {
							$('body').prepend('<div id="eu-banner">' + response.data.message + '</div>');
							setTimeout(function () {
								$('#eu-banner').slideDown('slow');
							}, 500); // 1-second delay
						}
					},
					error: function () { console.log('Failed to load banner.'); }
			
				});
			}
		}
	};



	// publish
	root.app = app;
	// init
	$( root ).ready(function() {
		app.init();
	});

	$(document).ready(function() {
		$(".toggle-site-navigation").on('click',function(){
			$(".site-navigation").slideToggle('show');
			$(".site-navigation").toggleClass('active');
			$(".fa-chevron-down").toggleClass('fa-chevron-up');
			$(".flag_icon").toggleClass('hide');
			$(".toggle-site-navigation-title").toggleClass('hide');
			$(".toggle-site-navigation-close").toggleClass('show');
		});
	});


})(window, document, jQuery);